import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["xlink:href"];
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const iconName = computed(() => `#icon-${props.name}`);
    const svgClass = computed(() => {
      const base = 'svg-icon';
      return props.className ? `${base} ${props.className}` : base;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("svg", _mergeProps({
        class: svgClass.value,
        "aria-hidden": "true"
      }, _ctx.$attrs), [_createElementVNode("title", null, _toDisplayString(props.title), 1), _createElementVNode("use", {
        "xlink:href": iconName.value
      }, null, 8, _hoisted_1)], 16);
    };
  }
});